module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('ul', {
    staticClass: "nav nav-pills pull-right"
  }, [_c('li', {
    staticClass: "dropdown"
  }, [_c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "data-toggle": "dropdown",
      "href": "#"
    }
  }, [_c('strong', [_vm._v(_vm._s(_vm.currentCycleTitle))]), _vm._v(" ( " + _vm._s(_vm.FormatDate(_vm.cycleStartDate)) + " - " + _vm._s(_vm.FormatDate(_vm.cycleEndDate)) + " )"), _c('span', {
    staticClass: "caret"
  })]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, [_vm._l((_vm.cycles), function(cycle, index) {
    return [(index == 0) ? [_c('li', [_c('a', {
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          if ($event.target !== $event.currentTarget) { return null; }
          _vm.setCycle(cycle)
        }
      }
    }, [_c('strong', {
      staticClass: "text-primary"
    }, [_vm._v("Next")]), _c('br'), _vm._v("\n                                    " + _vm._s(_vm.FormatDate(cycle.startDate)) + " - " + _vm._s(_vm.FormatDate(cycle.endDate)) + "\n                                ")])]), _vm._v(" "), _c('li', {
      staticClass: "divider"
    })] : _vm._e(), _vm._v(" "), (index == 1) ? [_c('li', [_c('a', {
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          if ($event.target !== $event.currentTarget) { return null; }
          _vm.setCycle(cycle)
        }
      }
    }, [_c('strong', {
      staticClass: "text-danger"
    }, [_vm._v(" Current")]), _c('br'), _vm._v("\n                                    " + _vm._s(_vm.FormatDate(cycle.startDate)) + " - " + _vm._s(_vm.FormatDate(cycle.endDate)) + "\n                                ")])]), _vm._v(" "), _c('li', {
      staticClass: "divider"
    })] : _vm._e(), _vm._v(" "), (index > 1) ? [_c('li', [_c('a', {
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          if ($event.target !== $event.currentTarget) { return null; }
          _vm.setCycle(cycle)
        }
      }
    }, [_vm._v("\n                                    " + _vm._s(_vm.FormatDate(cycle.startDate)) + " - " + _vm._s(_vm.FormatDate(cycle.endDate)) + "\n                                ")])])] : _vm._e()]
  })], 2)])])]), _vm._v(" "), (_vm.controller && _vm.controller.IsInitialized) ? _c('div', {
    staticClass: "row"
  }, [_c('div', [_c('table', {
    staticClass: "table",
    staticStyle: {
      "min-height": "100px"
    }
  }, [_c('thead'), _vm._v(" "), _c('tbody', [_vm._l((_vm.controller.DispensationItems), function(item) {
    return [
      [_c('tr', {
        class: {
          'row_changed': item.HasEndDateChanged
        }
      }, [_c('td', {
        staticClass: "no-border",
        staticStyle: {
          "padding-top": "10px"
        },
        attrs: {
          "colspan": "100"
        }
      }, [_vm._v("\n                                     \n                                    " + _vm._s(item.DatesDiff) + "\n                                ")])]), _vm._v(" "), _c('tr', {
        staticClass: "border_top",
        class: {
          'saved_medication': !item.IsVirtual && !item.IsNew,
            'unsaved_medication': item.IsVirtual && !item.IsNew,
            'new_medication': item.IsNew
        }
      }, [_c('td', {
        staticStyle: {
          "margin-top": "0px"
        },
        attrs: {
          "colspan": "100"
        }
      }, [(item.HasChanged && !item.IsNew) ? _c('a', {
        staticClass: "btn btn-md btn-warning",
        on: {
          "click": function($event) {
            $event.preventDefault();
            item.Reset()
          }
        }
      }, [_vm._v("Item Updated")]) : _vm._e(), _vm._v(" "), (item.HasChanged && !item.IsNew) ? _c('a', {
        staticClass: "btn btn-md btn-primary",
        on: {
          "click": function($event) {
            $event.preventDefault();
            item.Reset();
            item.IsUpdating = false
          }
        }
      }, [_vm._v("Reset Changes")]) : _vm._e(), _vm._v(" "), (item.IsUpdating && !item.HasChanged && !item.IsNew) ? _c('a', {
        staticClass: "btn btn-md btn-primary",
        on: {
          "click": function($event) {
            $event.preventDefault();
            item.Reset();
            item.IsUpdating = false
          }
        }
      }, [_vm._v("Close")]) : _vm._e(), _vm._v(" "), (item.IsNew) ? _c('a', {
        staticClass: "btn btn-md btn-info"
      }, [_vm._v("New Item")]) : _vm._e(), _vm._v(" "), (item.IsNew) ? _c('a', {
        staticClass: "btn btn-md btn-primary",
        on: {
          "click": function($event) {
            $event.preventDefault();
            _vm.controller.RemoveItem(item)
          }
        }
      }, [_vm._v("Remove \\ Cancel")]) : _vm._e(), _vm._v(" "), (item.hasError) ? _c('a', {
        staticClass: "btn btn-danger btn-md pull-right"
      }, [_c('i', {
        staticClass: "fa fa-exclamation-triangle"
      }), _vm._v(" Has Errors : " + _vm._s(item.message) + "\n                                    ")]) : _vm._e()])]), _vm._v(" "), _c('tr', {
        class: {
          'text-warning': item.HasEndDateChanged,
            'text-info': item.IsNew,
            'saved_medication': !item.IsVirtual && !item.IsNew,
            'unsaved_medication': item.IsVirtual && !item.IsNew,
            'new_medication': item.IsNew
        }
      }, [_c('td', {
        staticClass: "no-border",
        staticStyle: {
          "vertical-align": "middle"
        },
        attrs: {
          "colspan": "100"
        }
      }, [(!item.IsCycleActive) ? _c('span', {
        staticClass: " text-danger"
      }, [_c('i', {
        staticClass: "fa fa-exclamation-triangle fa-2x"
      }), _vm._v(" "), _c('span', {
        staticStyle: {
          "font-size": "20px"
        }
      }, [_vm._v("\n                                            [Inactive]\n                                        ")]), _vm._v("\n                                          \n                                    ")]) : _vm._e(), _vm._v(" "), _c('span', {
        class: {
          'text-info': item.IsNew, 'text-success': !item.IsVirtual && !item.IsNew, 'text-warning': item.IsVirtual
        }
      }, [_c('span', [(item.IsVirtual) ? _c('TooltipControl', {
        attrs: {
          "title": "Unsaved Medication"
        }
      }, [_c('i', {
        staticClass: "fa fa-circle-o fa-2x text-warning"
      })]) : _vm._e(), _vm._v(" "), (!item.IsVirtual && !item.IsNew) ? _c('TooltipControl', {
        attrs: {
          "title": "Saved Medication"
        }
      }, [_c('i', {
        staticClass: "fa fa-check-circle-o fa-2x text-success"
      })]) : _vm._e(), _vm._v(" "), (item.IsNew) ? _c('TooltipControl', {
        attrs: {
          "title": "New Medication"
        }
      }, [_c('i', {
        staticClass: "fa fa-circle-o fa-2x text-info"
      })]) : _vm._e()], 1), _vm._v("\n                                         \n\n                                        "), _vm._v(" "), _c('span', {
        staticStyle: {
          "font-size": "20px"
        }
      }, [_vm._v("\n                                            " + _vm._s(item.IsPharmacyDispensed ? "Pharmacy Dispensed" : "Carehome Added") + "\n                                        ")])]), _vm._v(" "), [(!item.IsNew && !item.IsVirtual) ? _c('span', [(!item.IsUpdating) ? _c('a', {
        staticClass: "btn btn-warning btn-xs",
        staticStyle: {
          "width": "100px",
          "margin": "2px"
        },
        on: {
          "click": function($event) {
            $event.preventDefault();
            _vm.EditItem(item)
          }
        }
      }, [_c('i', {
        staticClass: "fa fa-pencil"
      }), _vm._v(" Edit Details")]) : _vm._e(), _vm._v(" "), (!item.IsUpdating) ? _c('a', {
        staticClass: "btn btn-danger btn-xs",
        staticStyle: {
          "width": "125px",
          "margin": "2px"
        },
        on: {
          "click": function($event) {
            $event.preventDefault();
            _vm.StopItem(item)
          }
        }
      }, [_c('i', {
        staticClass: "fa fa-ban"
      }), _vm._v(" Stop Medication")]) : _vm._e(), _vm._v(" "), _c('button', {
        staticClass: "btn btn-xs btn-primary",
        on: {
          "click": function($event) {
            item.showInEMAR.value = !item.showInEMAR.value
          }
        }
      }, [_c('i', {
        staticClass: "fa fa-check"
      }), _vm._v("\n                                                " + _vm._s((item.showInEMAR.value ? "Disable" : "Enable") + " EMAR") + "\n                                            ")])]) : _vm._e(), _vm._v(" "), (!item.IsNew && item.IsVirtual) ? _c('span', [_c('a', {
        staticClass: "btn btn-warning btn-xs",
        staticStyle: {
          "width": "125px",
          "margin": "2px"
        },
        on: {
          "click": function($event) {
            $event.preventDefault();
            _vm.EditItem(item)
          }
        }
      }, [_c('i', {
        staticClass: "fa fa-pencil"
      }), _vm._v(" Edit Details")]), _vm._v(" "), (!item.IsUpdating && !item.HasVirtualItemStarted) ? _c('TooltipControl', {
        attrs: {
          "title": "Activate this medication"
        }
      }, [_c('a', {
        staticClass: "btn btn-success btn-xs",
        staticStyle: {
          "width": "125px",
          "margin": "2px"
        },
        on: {
          "click": function($event) {
            $event.preventDefault();
            _vm.StartItem(item)
          }
        }
      }, [_c('i', {
        staticClass: "fa fa-plus"
      }), _vm._v(" Start Medication")])]) : _vm._e(), _vm._v(" "), (!item.IsUpdating && !item.HasVirtualItemRemoved) ? _c('TooltipControl', {
        attrs: {
          "title": "Remove medication from the list"
        }
      }, [_c('a', {
        staticClass: "btn btn-danger btn-xs",
        staticStyle: {
          "width": "145px",
          "margin": "2px"
        },
        on: {
          "click": function($event) {
            $event.preventDefault();
            _vm.RemoveItem(item)
          }
        }
      }, [_c('i', {
        staticClass: "fa fa-ban"
      }), _vm._v(" Remove Medication")])]) : _vm._e()], 1) : _vm._e()]], 2)]), _vm._v(" "), (!item.IsNew) ? _c('tr', {
        staticClass: "border_top row_headers"
      }, [_c('th', [_vm._v("Drug")]), _vm._v(" "), _c('th', [_vm._v("Start Date")]), _vm._v(" "), _c('th', [_vm._v("End Date")]), _vm._v(" "), _c('th', [_vm._v("Quantity")]), _vm._v(" "), _c('th', [_vm._v("Notes")]), _vm._v(" "), _c('th', [_vm._v("Insulin")]), _vm._v(" "), _c('th', [_vm._v("EMAR")]), _vm._v(" "), _c('th', [_vm._v("CD")]), _vm._v(" "), _c('th', [_vm._v("BodyMap")])]) : _vm._e(), _vm._v(" "), (!item.IsNew) ? _c('tr', [_c('td', [_c('strong', {
        staticStyle: {
          "font-size": "18px"
        }
      }, [_vm._v(_vm._s(item.drug.value.searchText))])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.FormatDate(item.startDate.value)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.FormatDate(item.endDate.value)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.quantity.value) + " " + _vm._s(item.unitOfMeasure.value))]), _vm._v(" "), _c('td', [_vm._v("\n                                    " + _vm._s(item.notes.value) + "\n                                ")]), _vm._v(" "), _c('td', [_c('span', [(item.isInsulin.value) ? _c('i', {
        staticClass: "fa  fa-2x fa-check  text-success"
      }) : _vm._e()])]), _vm._v(" "), _c('td', [_c('span', [(item.showInEMAR.value) ? _c('i', {
        staticClass: "fa fa-2x fa-check  text-success"
      }) : _vm._e()])]), _vm._v(" "), _c('td', [_c('span', [(item.treatAsCD.value) ? _c('i', {
        staticClass: "fa  fa-2x fa-check  text-success"
      }) : _vm._e()])]), _vm._v(" "), _c('td', [_c('span', [(item.useBodyMap.value) ? _c('i', {
        staticClass: "fa fa-2x fa-check  text-success"
      }) : _vm._e()])])]) : _vm._e(), _vm._v(" "), (item.IsUpdating || item.IsNew) ? _c('tr', [_c('td', {
        attrs: {
          "colspan": "100"
        }
      }, [_c('DispensationItemBasicEditor', {
        attrs: {
          "controller": item
        }
      })], 1)]) : _vm._e(), _vm._v(" "), (!item.IsNew && !item.IsUpdating) ? _c('tr', {
        staticClass: "border_top row_headers"
      }, [_c('th', [_vm._v("Rounds")]), _vm._v(" "), _c('th', {
        attrs: {
          "colspan": "2"
        }
      }, [_vm._v("Dosage Pattern")]), _vm._v(" "), _c('th', {
        attrs: {
          "colspan": "2"
        }
      }, [_vm._v("Dosage Instruction")]), _vm._v(" "), _c('th', {
        attrs: {
          "colspan": "20"
        }
      })]) : _vm._e(), _vm._v(" "), (!item.IsNew && !item.IsUpdating) ? _c('tr', {
        staticClass: "dosagerow"
      }, [_c('td', {
        attrs: {
          "colspan": "1"
        }
      }, [_c('table', {
        staticClass: "roundTable",
        staticStyle: {
          "background": "#eeeded!important"
        }
      }, [_vm._m(0, true), _vm._v(" "), _c('tbody', {
        staticStyle: {
          "font-size": "13px"
        }
      }, _vm._l((_vm.NonZeroRounds(item.Original.medRounds)), function(round) {
        return _c('tr', {
          staticClass: "border_top_thin"
        }, [_c('td', [_vm._v(_vm._s(round.displayTextRound))]), _vm._v(" "), _c('td', [_c('span', {
          style: ({
            'background': _vm.HexColour(round.colourHex)
          })
        }, [_vm._v("\n                                                           \n                                                    ")]), _vm._v("\n                                                     \n                                                    "), _c('span', [_c('strong', [_vm._v(_vm._s(_vm.formatTime(round.roundTime)))])])]), _vm._v(" "), _c('td', {
          staticStyle: {
            "text-align": "center"
          }
        }, [_vm._v(_vm._s(round.dosage))])])
      }))])]), _vm._v(" "), _c('td', {
        attrs: {
          "colspan": "2"
        }
      }, [_vm._v("\n                                    " + _vm._s(_vm.MapDaysOfDosage(item.Original.daysOfDosagePattern)) + "\n                                ")]), _vm._v(" "), _c('td', {
        attrs: {
          "colspan": "2"
        }
      }, [_vm._v("\n                                    " + _vm._s(item.Original.dosageInstruction) + "\n                                ")]), _vm._v(" "), _c('td', {
        attrs: {
          "colspan": "20"
        }
      })]) : _vm._e(), _vm._v(" "), (item.IsUpdating || item.IsNew) ? _c('tr', [_c('td', {
        attrs: {
          "colspan": "100"
        }
      }, [_c('DispensationItemEditor', {
        attrs: {
          "controller": item
        }
      })], 1)]) : _vm._e()]
    ]
  }), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "100"
    }
  }, [_c('br'), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info",
    on: {
      "click": function($event) {
        _vm.controller.CreateItem()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" Add Item")])])])], 2)])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.controller.hasError, 'has-warning': _vm.controller.hasWarning, 'has-success': _vm.controller.hasSuccess
    }
  }, [_c('a', {
    staticClass: "btn btn-warning",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        if ($event.target !== $event.currentTarget) { return null; }
        _vm.controller.Save()
      }
    }
  }, [_vm._v("Submit")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-warning",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        if ($event.target !== $event.currentTarget) { return null; }
        _vm.controller.Reset()
      }
    }
  }, [_vm._v("Reset")]), _vm._v(" "), _c('span', {
    staticClass: "help-block"
  }, [_vm._v(_vm._s(_vm.controller.message))])]), _vm._v(" "), (_vm.controller.ChangeCount > 0) ? _c('div', {
    attrs: {
      "id": "foo"
    }
  }, [_c('div', {
    staticClass: "alert alert-dismissible alert-warning",
    staticStyle: {
      "margin": "10px",
      "opacity": "0.6"
    }
  }, [_c('strong', [_vm._v(_vm._s(_vm.controller.ChangeCount) + " Pending Changes. ")]), _c('br'), _vm._v(" Press submit to save.\n            ")]), _vm._v(" "), (_vm.controller.hasError) ? _c('div', {
    staticClass: "alert alert-dismissible alert-danger",
    staticStyle: {
      "margin": "10px",
      "opacity": "0.6"
    }
  }, [_c('strong', [_vm._v("Clear all errors to save")]), _c('br')]) : _vm._e()]) : _vm._e()]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_c('strong', [_vm._v("Round")])]), _vm._v(" "), _c('th', [_vm._v("Time")]), _vm._v(" "), _c('th', [_vm._v("Quantity")])])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-3f357096", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3f357096"}!./~/vue-loader/lib/selector.js?type=template&index=0!./ClientApp/components/appcontrols/PatientMedProfile2/PatientMedProfile2.scp.html
// module id = 471
// module chunks = 0